import { render, staticRenderFns } from "./NewDebrisType.vue?vue&type=template&id=e564b6d6&"
import script from "./NewDebrisType.vue?vue&type=script&lang=js&"
export * from "./NewDebrisType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports